// Turks (tr-TR), food: zelfde vorm als food.nl.ts. Wat ontbreekt valt terug op het Nederlands
// (nooit een rauwe sleutel op het scherm). Eenheden zoals in Turkse recepten (su bardağı, tutam).
export const foodTr = {
    nav: 'Yemek',
    title: 'Yemek',
    tabs: {
        shopping: 'Alışveriş',
        recipes: 'Tarifler',
        menu: 'Haftalık menü',
        pantry: 'Kiler',
    },
    undo: 'Geri al',
    save: 'Kaydet',
    cancel: 'Vazgeç',
    close: 'Kapat',
    remove: 'Sil',
    retry: 'Tekrar dene',
    errorLoad: 'Yükleme olmadı. Tekrar dene.',
    errorSave: 'Kaydetme olmadı. Tekrar dene.',
    categories: {
        produce: 'Sebze ve meyve',
        bakery: 'Ekmek ve kahvaltılık',
        dairy: 'Süt ürünleri ve yumurta',
        meat: 'Et ve balık',
        pantry: 'Kiler',
        drinks: 'İçecekler',
        household: 'Ev ihtiyaçları',
        other: 'Diğer',
    },
    units: {
        g: 'gram',
        kg: 'kilo',
        ml: 'ml',
        cl: 'cl',
        dl: 'dl',
        l: 'litre',
        el: 'yemek kaşığı',
        tl: 'çay kaşığı',
        kop: 'su bardağı',
        snuf: 'tutam',
        stuk: 'adet',
        teen: 'diş',
        blik: 'konserve',
        pak: 'paket',
        zak: 'poşet',
        bos: 'demet',
        plak: 'dilim',
        fles: 'şişe',
        doos: 'kutu',
        krop: 'baş',
        pot: 'kavanoz',
        takje: 'dal',
        handje: 'avuç',
        scheut: 'az miktar',
    },
    shopping: {
        addLabel: 'Ne lazım?',
        addPlaceholder: 'Örneğin 2 paket süt',
        add: 'Ekle',
        frequent: 'Sık alınanlar',
        inBasket: 'Sepetinde ({count})',
        clearChecked: 'İşaretlileri sil',
        newList: 'Liste',
        newListTitle: 'Yeni liste',
        listName: 'Listenin adı',
        listNameHint: 'Örneğin Pazar ya da Eczane',
        listsLabel: 'Alışveriş listeleri',
        renameList: 'Listeyi değiştir',
        archiveList: 'Listeyi sil',
        listMenu: 'Bu liste için daha fazla',
        archiveAsk: '{name} listesi silinsin mi?',
        archiveHint: 'İçindekiler de gider. Hemen geri alabilirsin.',
        archivedList: '{name} listesi silindi',
        lastList: 'Son liste silinemez. Ona başka bir ad ver.',
        emptyTitle: 'Evde her şey var',
        emptyBody: 'Listeye buradan ekle; herkes hemen görür.',
        added: '{name} listede',
        merged: '{name}: şimdi {amount}',
        removed: '{name} silindi',
        cleared: 'İşaretli ürünler silindi',
        viaTablet: 'tabletten',
        forRecipe: '{title} için',
        editItem: 'Ürünü değiştir',
        name: 'Ad',
        amount: 'Miktar',
        unit: 'Birim',
        noUnit: 'Yok',
        note: 'Not',
        icon: 'Simge',
        list: 'Liste',
        check: 'İşaretle: {name}',
        uncheck: 'Geri al: {name}',
        addedBy: 'Ekleyen: {name}',
    },
    recipes: {
        search: 'Tarif ara',
        filterAll: 'Tümü',
        filterOwn: 'Bizim',
        filterLibrary: 'Koleksiyon',
        add: 'Tarif',
        newTitle: 'Yeni tarif',
        editTitle: 'Tarifi değiştir',
        modeManual: 'Kendin yaz',
        modeLink: 'Bağlantıdan',
        link: 'Tarifin bağlantısı',
        linkHint: 'Tarif siteleriyle ve YouTube, TikTok ve Instagram ile çalışır.',
        fetch: 'Getir',
        fetching: 'Tarif getiriliyor…',
        name: 'Tarifin adı',
        description: 'Kısa açıklama',
        servings: 'Kişi',
        minutes: 'Dakika',
        ingredients: 'Malzemeler',
        ingredientsHint: 'Her satıra bir tane, örneğin 500 g kıyma',
        steps: 'Yapılışı',
        stepsHint: 'Her satıra bir adım',
        minutesShort: '{n} dk',
        people: '{n} kişilik',
        video: 'Video',
        needsIngredients: 'Malzemeleri ekle',
        noResults: 'Tarif bulunamadı',
        noResultsBody: 'Başka bir kelime dene ya da kendin bir tarif ekle.',
        emptyTitle: 'Henüz tarif yok',
        emptyBody: 'İlk tarifini ekle ya da bir bağlantıdan getir.',
        toMenu: 'Menüye ekle',
        toList: 'Listeye ekle',
        edit: 'Düzenle',
        photo: 'Fotoğraf ekle',
        changePhoto: 'Başka fotoğraf',
        removePhoto: 'Fotoğrafı kaldır',
        photoUploading: 'Fotoğraf yükleniyor…',
        photoTooLarge: 'Bu fotoğraf çok büyük.',
        photoUnsupported: 'Bu dosya kullanabileceğimiz bir fotoğraf değil.',
        archive: 'Gizle',
        archived: '{title} gizlendi',
        openVideo: 'Videoyu izle',
        openSource: 'Web sitesine git',
        back: 'Tüm tarifler',
        fromLibrary: 'Koleksiyondan',
        ingredientsEmpty: 'Henüz malzeme yok.',
        stepsEmpty: 'Henüz yapılışı yok.',
        toListTitle: 'Alışveriş listesine ekle',
        toListBody: 'Kilerde olanlar ya da evde hep bulunanlar işaretsiz.',
        toListDo: 'Listeye ekle',
        toListDone: '{count} ürün eklendi: {list}',
        toListMerged: '{count} ürün eklendi: {list}, {merged} birleştirildi',
        toListNothing: 'Hepsi zaten listede ya da evde var.',
        staple: 'evde hep var',
        inPantry: 'evde var',
        pickDayTitle: 'Menüye ekle',
        pickDay: 'Bir gün seç',
        planned: '{title} menüde: {day}',
        created: '{title} eklendi',
        imported: '{title} getirildi',
        importErrors: {
            no_recipe_found: 'Bu sayfada okuyabileceğimiz bir tarif yok. Kendin yazmak ister misin?',
            blocked_address: 'Bu bağlantıyı açamıyoruz.',
            invalid_url: 'Güvenli bir bağlantı kullan (https ile başlayan).',
            too_large: 'Bu sayfa okunamayacak kadar büyük.',
            timeout: 'Web sitesi zamanında yanıt vermedi. Daha sonra tekrar dene.',
            fetch_failed: 'Web sitesine şu an ulaşılamıyor.',
        },
        fillManually: 'Kendin yaz',
    },
    menu: {
        week: '{week}. hafta',
        range: '{from} – {to}',
        thisWeek: 'Bu hafta',
        prev: 'Önceki hafta',
        next: 'Sonraki hafta',
        allToList: 'Hepsini listeye ekle',
        choose: 'Seç',
        chooseFor: 'Ne yiyeceğimizi seç: {day}',
        dragHint: 'Bir tarifi bir güne sürükle',
        tapHint: 'Bir günün yanındaki + Seç düğmesine dokun',
        moreRecipes: 'Daha fazla tarif ({count})',
        freeSection: 'Ya da başka bir şey, örneğin Dışarıda yemek',
        freeSave: 'Menüye ekle',
        pickRecipe: 'Bir tarif seç',
        shelf: 'Tarifler',
        removeMeal: '{title} menüden kaldır',
        removed: '{title} menüden kaldırıldı',
        moved: 'Taşındı: {day}',
        freeText: 'Ya da başka bir şey yaz',
        freePlaceholder: 'Örneğin Dışarıda yemek',
        emptyTitle: 'Menüde henüz bir şey yok',
        emptyBody: 'Bir tarifi bir güne sürükle.',
        today: 'bugün',
        nothingToList: 'Bu hafta menüde henüz tarif yok.',
        servings: '{n} kişilik',
    },
    pantry: {
        addLabel: 'Evde neler var?',
        addPlaceholder: 'Örneğin 1 kg patates',
        add: 'Ekle',
        listLabel: 'Kilerde',
        removeItem: '{name} kilerden çıkar',
        removed: '{name} kilerden çıkarıldı',
        suggestionsTitle: 'Ne yapabiliriz?',
        allInHouse: 'Hepsi evde var',
        stillNeeded: 'Daha lazım: {items}',
        emptyTitle: 'Kilerde henüz bir şey yok',
        emptyBody: 'Elindekileri ekle; ne yapabileceğini biz düşünelim.',
        noSuggestions: 'Henüz evdekilerle yapılabilecek bir tarif yok.',
        staples: 'Tuz, karabiber, yağ ve su evde hep var sayılır.',
    },
    kiosk: {
        entry: 'Yemek',
        back: 'Geri',
        tonight: 'Bu akşam yemekte',
        nothingPlanned: 'Henüz plan yok',
        nothingPlannedBody: 'Annen ya da baban uygulamadan seçer.',
        tomorrow: 'Yarın',
        add: 'Ekle',
        addTitle: 'Ne lazım?',
        close: 'Kapat',
        added: '{name} listede',
        oops: 'Hay aksi',
        emptyTitle: 'Evde her şey var',
        check: '{name}: sepette mi?',
        // UX-ronde bord: een regel in het mandje met één tik terugzetten.
        backOnList: '{name}: listeye geri koy',
        confirm: 'Sepette',
        shopping: 'Alışveriş',
        week: 'Bu hafta',
        inBasket: '{name} sepette',
        more: 'Daha fazla ürün',
        alreadyOn: '{name} zaten listedeydi',
        typeOwn: 'Kendin yaz',
        typeLabel: 'Ne lazım?',
        typePlaceholder: 'Örn. çikolata',
        typeAdd: 'Ekle',
        closeTyping: 'Resimlere dön',
        moreTiles: 'Daha fazla resim',
    },
};
//# sourceMappingURL=food.tr.js.map